// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__umOJE","fullView":"styles_fullView__2LmdS"};